module.exports = __webpack_public_path__ + "img/onboarding-icon-4.7aad54e6.svg";